// extracted by mini-css-extract-plugin
export default {"headerContainer":"header_headerContainer__WceFj","iconContainer":"header_iconContainer__FBbO5"};